<div class="button-container" (click)="open()">
    <ng-content select="button"></ng-content>
    <div class="popout-card-container" [class.left]="leftAlign">
        <div class="popout-card" [class.open]="isOpen">
            <div class="popout-content">
                <ng-content select=".popout"></ng-content>
            </div>
            <div class="arrow-down"></div>
        </div>
    </div>
</div>

<a href="javascript:;" class="underlay" (click)="close()" [class.open]="isOpen">

</a>